import { CheckCircleIcon } from '@shape-construction/arch-ui/src/Icons/solid';
import QRCorners from 'app/components/UI/Icons/QRCorners';
import { environment } from 'app/config/environment';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

const AccessRequestedPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const projectName = searchParams.get('projectName') ?? '';

  return (
    <div className="p-8 flex flex-col items-center">
      <div className="mb-16 w-full max-w-md text-center flex flex-col items-center gap-6">
        <div className="flex flex-col items-center p-4 gap-4 w-full bg-white shadow-sm rounded-lg">
          <div className="flex items-center justify-center w-10 h-10 bg-emerald-100 rounded-full">
            <CheckCircleIcon className="w-6 h-6 text-emerald-600" />
          </div>
          <div className="flex flex-col items-start gap-2 w-full">
            <span className="w-full text-lg font-medium leading-6 text-center text-gray-800">
              {t('channels.accessRequested.title')}
            </span>
            <span className="w-full text-sm font-normal leading-5 text-center text-gray-500">
              {t('channels.accessRequested.description', { projectName })}
            </span>
          </div>
        </div>
        <div className="flex flex-col items-center gap-2 w-full">
          <div className="flex flex-row gap-4">
            <a href={environment.CHANNELS_APP_STORE_URL} target="_blank" rel="noreferrer">
              <img alt="app store" src="/images/store/appstore.png" className="h-10" />
            </a>
            <a href={environment.CHANNELS_PLAY_STORE_URL} target="_blank" rel="noreferrer">
              <img alt="google play" src="/images/store/googleplay.png" className="h-10" />
            </a>
          </div>
          <span className="text-sm font-normal leading-5 text-center text-gray-800">
            {t('channels.accessRequested.downloadDescription')}
          </span>
          <span className="text-sm font-normal leading-5 text-center text-gray-800">
            {t('channels.accessRequested.scanQR')}
          </span>
          <div className="relative flex items-center justify-center w-[195px] h-[195px]">
            <QRCorners className="absolute inset-0 w-full h-full" />
            <img
              alt={t('channels.accessRequested.qrCodeAlt')}
              src="/images/store/qr-install.png"
              className="w-44 h-44"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessRequestedPage;
